export default "__VITE_ASSET__DXoR$Lcw__"